module.exports = __webpack_public_path__ + "static/media/icon_p.ba893b47.svg";